import { formatAttributeDisplay as formatAttrFromSchema } from './periodizationValueSchema';

export const PERIOD_BUCKETS = ['block', 'phase', 'week', 'day', 'session'];

export const EMPTY_BUCKETS = { block: false, phase: false, week: false, day: false, session: false };

export function normalizePeriodBuckets(input, fallback = EMPTY_BUCKETS) {
  const src = typeof input === 'string' ? (() => {
    try {
      return JSON.parse(input);
    } catch {
      return {};
    }
  })() : input || {};
  const base = { ...EMPTY_BUCKETS, ...fallback };
  return PERIOD_BUCKETS.reduce((acc, key) => {
    acc[key] = !!src[key];
    return acc;
  }, { ...base });
}

export function intersectPeriodBuckets(allowed, enabled) {
  const a = normalizePeriodBuckets(allowed);
  const e = normalizePeriodBuckets(enabled);
  return PERIOD_BUCKETS.reduce((acc, key) => {
    acc[key] = a[key] && e[key];
    return acc;
  }, { ...EMPTY_BUCKETS });
}

export function calendarVisibleBuckets(enabledBuckets) {
  const e = normalizePeriodBuckets(enabledBuckets);
  return PERIOD_BUCKETS.filter((b) => e[b] && (b === 'block' || b === 'phase' || b === 'week'));
}

export function resolveAttributeValueForWeek({ typeKey, enabledBuckets, block, phase, micro }) {
  const enabled = normalizePeriodBuckets(enabledBuckets);
  if (enabled.week && micro?.attributes && micro.attributes[typeKey] != null) {
    return { value: micro.attributes[typeKey], bucket: 'week' };
  }
  if (enabled.phase && phase?.attributes && phase.attributes[typeKey] != null) {
    return { value: phase.attributes[typeKey], bucket: 'phase' };
  }
  if (enabled.block && block?.attributes && block.attributes[typeKey] != null) {
    return { value: block.attributes[typeKey], bucket: 'block' };
  }
  return { value: null, bucket: null };
}

export const VALUE_KIND_COUNT_RANGES = {
  count_0_5: { min: 0, max: 5, default: 0 },
  count_1_7: { min: 1, max: 7, default: 4 },
};

export function clampCountValue(value, valueKind) {
  const range = VALUE_KIND_COUNT_RANGES[valueKind];
  if (!range) return value;
  const n = typeof value === 'number' ? value : range.default;
  return Math.min(range.max, Math.max(range.min, n));
}

export function formatAttributeDisplay(value, valueKindOrType) {
  if (typeof valueKindOrType === 'object' && valueKindOrType != null) {
    return formatAttrFromSchema(value, valueKindOrType);
  }
  return formatAttrFromSchema(value, { value_kind: valueKindOrType });
}
